<template>
	<b-modal ref="modal" class="modal-primary" @ok="onOkModal" @cancel="onCancelModal" :title="modalTitle" :ok-title="modalOkTitle" :cancel-title="modalCancelTitle" :busy="modalIsBusy">
		<b-form ref="form" novalidate>
			<app-mbox v-if="modalErrorMsg" :text="modalErrorMsg" @dismissed="clear_error_msg"></app-mbox>
			<b-row>
				<b-col sm="6">
					<b-form-group>
						<label for="oldPassword2">Prejšnje geslo</label>
						<b-form-input type="password" id="OldPassword" v-model="modalUser.oldPassword" min="8" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col sm="6">
					<b-form-group>
						<label for="newPassword">Novo geslo</label>
						<b-form-input type="password" id="NewPassword" v-model="modalUser.newPassword" min="8" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col sm="6">
					<b-form-group>
						<label for="newPassword2">Novo Geslo (ponovno)</label>
						<b-form-input type="password" id="NewPassword2" v-model="modalUser.newPassword2" min="8" autocomplete="off"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
		</b-form>
	</b-modal>
</template>
<style>
</style>
<script>
import firebase from 'firebase';

export default {
	name: 'editUserPsswordModal',
	methods: {
		showModal: function (user) {
			console.log('Show modal ' + user.email + '-' + user.id);
			this.modalUser.id = user.id;
			this.modalUser.email = user.email;
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			this.modalErrorMsg = null;
			this.$refs.form.classList.add('was-validated');
			if (!this.$refs.form.checkValidity()) {
				this.modalErrorMsg = 'Označena polja so nepravilno izpolnjena';
				return;
			} else {
				if (this.modalUser.newPassword === '' || this.modalUser.newPassword !== this.modalUser.newPassword2) {
					this.modalErrorMsg = 'Gesli se ne ujemata';
					return;
				}
			}
			var context = this;
			firebase.auth().signInWithEmailAndPassword(this.modalUser.email, this.modalUser.oldPassword)
				.then(
					fbUser => {
						fbUser.user.updatePassword(this.modalUser.newPassword)
							.then(function () {
								context.modalIsBusy = false;
								context.$emit('edit_password');
								context.clearModal();
								context.$refs.modal.hide();
							})
							.catch(function (error) {
								console.log('Error: ' + error);
								context.modalIsBusy = false;
								context.modalErrorMsg = 'Napaka pri spreminjanju gesla.';
							})
					}
				)
				.catch(error => {
					console.log('Error: ' + error);
					this.modalIsBusy = false;
					this.modalErrorMsg = 'Napačno prejšnje geslo.';
				});
		},
		onCancelModal: function (evt) {
			this.clearModal();
			this.$refs.modal.hide();
		},
		clearModal: function () {
			this.modalErrorMsg = null;
			this.modalIsBusy = false;
			this.modalUser.id = 0;
			this.modalUser.email = '';
			this.modalUser.oldPassword = '';
			this.modalUser.newPassword = '';
			this.modalUser.newPassword2 = '';
		},
		clear_error_msg: function (event) {
			this.modalErrorMsg = null;
		}
	},
	data: function () {
		return {
			modalErrorMsg: null,
			modalIsBusy: false,
			modalTitle: 'Sprememba gesla',
			modalOkTitle: 'Spremeni',
			modalCancelTitle: 'Prekliči',
			modalUser: {
				id: 0,
				email: '',
				oldPassword: '',
				newPassword: '',
				newPassword2: ''
			}
		};
	}
};
</script>


// WEBPACK FOOTER //
// src/components/EditUserPasswordModal.vue